import { axios } from '@/utils/request'

// 查询员工列表
export function getStaffList(params) {
  return axios({
    url: `/admin_users`,
    method: 'get',
    params
  })
}

//删除员工
export function deleteStaff(params) {
  return axios({
    url: `/admin_user/${params}`,
    method: 'delete',
    params
  })
}

//新增/编辑员工
export function updateStaff(params) {
  return axios({
    url: `/admin_user/save`,
    method: 'post',
    data: params
  })
}